<select #comboBox [(ngModel)]="selectedTagId" [disabled]="disabled" [hidden]="!visible"
  (change)="update($event);onChange($any($event.target).value);" (blur)="onTouched()" [style.width.px]="width"
  [style.width]="undefined !== width ? width : '100%'" [tabindex]="tabindex" [class.combo-box-required]="required">
  <ng-template ngFor let-item [ngForOf]="model.tagList">
    <option value="{{item.TagId}}">{{item.TagIdName}}</option>
  </ng-template>
</select>